import React, { Fragment } from 'react';
import { motion } from 'framer-motion';
interface SlideProps {
  index: number;
  total: number;
}
export function Slide05Different({
  index
}: SlideProps) {
  return <div className="relative w-screen h-screen overflow-hidden bg-[var(--surface)] p-[clamp(2rem,4vw,4rem)]" data-id="element-108">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2,
      duration: 0.6
    }} className="mb-[clamp(2rem,4vw,3rem)]" data-id="element-109">
        <h2 className="text-[var(--fg)] font-bold text-[clamp(2rem,4vw,3.5rem)] leading-[1.1]" data-id="element-110">
          <span className="text-[var(--brand-green-light)]" data-id="element-111">Not</span> webinar
          snippets. Educational episodes.
        </h2>
      </motion.div>

      {/* Two column comparison */}
      <div className="grid grid-cols-2 gap-[clamp(2rem,4vw,4rem)] mb-[clamp(2rem,3vw,3rem)]" data-id="element-112">
        {/* Traditional */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="bg-white rounded-2xl p-[clamp(1.5rem,3vw,3rem)]" data-id="element-113">
          <h3 className="text-[var(--muted)] font-bold text-[clamp(1.25rem,2vw,1.75rem)] mb-[clamp(1.5rem,2.5vw,2rem)]" data-id="element-114">
            Traditional Webinar Repurposing
          </h3>
          <ul className="space-y-[clamp(0.75rem,1.5vw,1.25rem)]" data-id="element-115">
            {['Short clips', 'Isolated highlights', 'Limited story', 'Short lifespan'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-116">
                <span className="text-gray-400 text-[clamp(1rem,1.5vw,1.25rem)] mt-1" data-id="element-117">
                  •
                </span>
                <span className="text-[var(--fg)] text-[clamp(1rem,1.75vw,1.5rem)]" data-id="element-118">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        {/* DERMX Model */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="bg-[var(--brand-green)] rounded-2xl p-[clamp(1.5rem,3vw,3rem)]" data-id="element-119">
          <h3 className="text-white font-bold text-[clamp(1.25rem,2vw,1.75rem)] mb-[clamp(1.5rem,2.5vw,2rem)]" data-id="element-120">
            DERMX Series Model
          </h3>
          <ul className="space-y-[clamp(0.75rem,1.5vw,1.25rem)]" data-id="element-121">
            {['Structured episodes', 'Narrative storytelling', 'Countdown to next episode', 'Repeat engagement', 'Evergreen value'].map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-122">
                <span className="text-[var(--brand-green-lighter)] text-[clamp(1rem,1.5vw,1.25rem)] mt-1" data-id="element-123">
                  •
                </span>
                <span className="text-white text-[clamp(1rem,1.75vw,1.5rem)]" data-id="element-124">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>

      {/* Episode progression visual */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.7,
      duration: 0.6
    }} className="flex items-center justify-center gap-4 mb-[clamp(2rem,3vw,3rem)]" data-id="element-125">
        {['Episode 1', 'Episode 2', 'Episode 3', 'Full Webinar'].map((item, idx) => <Fragment key={item} data-id="element-126">
              <div className="bg-white rounded-lg px-4 py-2" data-id="element-127">
                <span className="text-[var(--brand-green)] font-semibold text-[clamp(0.875rem,1.25vw,1rem)]" data-id="element-128">
                  {item}
                </span>
              </div>
              {idx < 3 && <span className="text-[var(--brand-green)] font-bold" data-id="element-129">→</span>}
            </Fragment>)}
      </motion.div>

      {/* Bottom statement */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.9,
      duration: 0.6
    }} className="flex justify-between items-end" data-id="element-130">
        <p className="text-[var(--fg)] text-[clamp(1rem,1.75vw,1.5rem)] font-semibold" data-id="element-131">
          Designed to create anticipation and repeat viewing behaviour.
        </p>
        <span className="text-[var(--muted)] text-sm" data-id="element-132">{index + 1}</span>
      </motion.div>
    </div>;
}